module.exports = __webpack_public_path__ + "static/media/footer-notifications-active.d21c607c.png";